export default {
    PLAN: 'plan',
    BLOCK: 'block',
    MICROCYCLE_SESSION: 'microcycle_session',
    MICROCYCLE: 'microcycle'
};
